import { useEffect, useRef } from 'react'
import { useSelector } from 'react-redux'
import { useLocation } from 'react-router'

import { selectApplovinPixelId } from '~/shared/store/common/selects'

export const useApplovinPixelInitialization = (): void => {
  const { pathname } = useLocation()
  const previousPathRef = useRef(pathname)
  const applovinPixelId = useSelector(selectApplovinPixelId)

  useEffect(() => {
    if (!applovinPixelId) return

    if (document.getElementById('applovin-axon-sdk')) return

    const axonScript = document.createElement('script')
    axonScript.id = 'applovin-axon-sdk'
    axonScript.type = 'text/javascript'
    axonScript.text = `
      var AXON_EVENT_KEY="${applovinPixelId}";
      !function(e,r){var
      t=["https://s.axon.ai/pixel.js","https://res4.applovin.com/p/l/loader.iife.js"];if(!e
      .axon){var
      a=e.axon=function(){a.performOperation?a.performOperation.apply(a,arguments):a.
      operationQueue.push(arguments)};a.operationQueue=[],a.ts=Date.now(),a.eventKey=
      AXON_EVENT_KEY;for(var
      n=r.getElementsByTagName("script")[0],o=0;o<t.length;o++){var
      i=r.createElement("script");i.async=!0,i.src=t[o],n.parentNode.insertBefore(i,n
      )}}}(window,document);
      axon("init");
    `

    document.body.appendChild(axonScript)
  }, [applovinPixelId])

  useEffect(() => {
    if (pathname === '/' || pathname === previousPathRef.current) return

    if (!applovinPixelId || !window.axon?.eventKey) return

    window?.axon?.('track', 'page_view')
    previousPathRef.current = pathname
  }, [pathname, applovinPixelId])
}
